module.exports = __webpack_public_path__ + "img/ic_no_data.68d8e48e.png";